// src/components/AdminDashboard.js

import React, { useEffect, useState } from 'react';
import styles from './AdminDashboard.module.css';
import {
  collection,
  getDocs,
  addDoc,
  deleteDoc,
  updateDoc,
  doc,
} from 'firebase/firestore';
import { db } from '../../firebase';

const AdminDashboard = () => {
  const [articles, setArticles] = useState([]);
  const [newArticle, setNewArticle] = useState({
    article_name: '',
    article_url: '',
    article_brief: '',
  });
  const [editingId, setEditingId] = useState(null);
  const [editData, setEditData] = useState({});

  const loadArticles = async () => {
    const snapshot = await getDocs(collection(db, 'linkedin_articles'));
    const data = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
    setArticles(data);
    localStorage.setItem('admin_articles', JSON.stringify(data));
    localStorage.setItem('admin_articles_timestamp', Date.now().toString());
  };

  useEffect(() => {
    const cached = localStorage.getItem('admin_articles');
    const lastFetch = localStorage.getItem('admin_articles_timestamp');
    const isFresh =
      lastFetch && Date.now() - parseInt(lastFetch, 10) < 10 * 60 * 1000;

    if (cached && isFresh) {
      setArticles(JSON.parse(cached));
    } else {
      loadArticles();
    }
  }, []);

  const handleAdd = async () => {
    if (
      !newArticle.article_name ||
      !newArticle.article_url ||
      !newArticle.article_brief
    )
      return;

    await addDoc(collection(db, 'linkedin_articles'), newArticle);
    setNewArticle({ article_name: '', article_url: '', article_brief: '' });
    loadArticles();
  };

  const handleDelete = async (id) => {
    const confirm = window.confirm('Are you sure you want to delete this article?');
    if (!confirm) return;
    await deleteDoc(doc(db, 'linkedin_articles', id));
    loadArticles();
  };

  const startEdit = (article) => {
    setEditingId(article.id);
    setEditData({ ...article });
  };

  const cancelEdit = () => {
    setEditingId(null);
    setEditData({});
  };

  const handleSaveEdit = async () => {
    const { article_name, article_url, article_brief } = editData;
    if (!article_name || !article_url || !article_brief) return;

    const docRef = doc(db, 'linkedin_articles', editingId);
    await updateDoc(docRef, { article_name, article_url, article_brief });
    setEditingId(null);
    setEditData({});
    loadArticles();
  };

  return (
    <div className={styles.dashboardWrapper}>
      <header className={styles.header}>
        <h1>Admin Dashboard</h1>
      </header>

      <div className={styles.formSection}>
        <h2>Add New Article</h2>
        <input
          type="text"
          placeholder="Article Name"
          value={newArticle.article_name}
          onChange={(e) =>
            setNewArticle({ ...newArticle, article_name: e.target.value })
          }
        />
        <input
          type="text"
          placeholder="Article URL"
          value={newArticle.article_url}
          onChange={(e) =>
            setNewArticle({ ...newArticle, article_url: e.target.value })
          }
        />
        <textarea
          rows="3"
          placeholder="Article Brief"
          value={newArticle.article_brief}
          onChange={(e) =>
            setNewArticle({ ...newArticle, article_brief: e.target.value })
          }
        />
        <button onClick={handleAdd}>Add Article</button>
      </div>

      <div className={styles.articleList}>
        <h2>Posted Articles</h2>
        {articles.map((a) => (
          <div key={a.id} className={styles.articleCard}>
            {editingId === a.id ? (
              <div className={styles.editForm}>
                <input
                  type="text"
                  value={editData.article_name}
                  onChange={(e) =>
                    setEditData({ ...editData, article_name: e.target.value })
                  }
                />
                <input
                  type="text"
                  value={editData.article_url}
                  onChange={(e) =>
                    setEditData({ ...editData, article_url: e.target.value })
                  }
                />
                <textarea
                  rows="3"
                  value={editData.article_brief}
                  onChange={(e) =>
                    setEditData({ ...editData, article_brief: e.target.value })
                  }
                />
                <div className={styles.editActions}>
                  <button onClick={handleSaveEdit}>💾 Save</button>
                  <button onClick={cancelEdit}>❌ Cancel</button>
                </div>
              </div>
            ) : (
              <>
                <div>
                  <strong>{a.article_name}</strong>
                  <p>{a.article_brief}</p>
                  <a href={a.article_url} target="_blank" rel="noopener noreferrer">
                    View
                  </a>
                </div>
                <div className={styles.cardActions}>
                  <button onClick={() => startEdit(a)}>✏️</button>
                  <button onClick={() => handleDelete(a.id)}>🗑</button>
                </div>
              </>
            )}
          </div>
        ))}
        {articles.length === 0 && <p>No articles available.</p>}
      </div>
    </div>
  );
};

export default AdminDashboard;






// import { useEffect, useState } from 'react';
// import { collection, getDocs, deleteDoc, doc } from 'firebase/firestore';
// import { auth, db } from '../../firebase';
// import { useNavigate } from 'react-router-dom';
// import { useToast } from '../../context/ToastContext';
// import ArticleForm from './ArticleForm';
// import styles from './AdminDashboard.module.css';

// const AdminDashboard = () => {
//   const [articles, setArticles] = useState([]);
//   const [editingArticle, setEditingArticle] = useState(null);
//   const toast = useToast();
//   const navigate = useNavigate();

//   const fetchArticles = async () => {
//     const snap = await getDocs(collection(db, 'linkedin_articles'));
//     setArticles(snap.docs.map(doc => ({ id: doc.id, ...doc.data() })));
//   };

//   const handleDelete = async (id) => {
//     await deleteDoc(doc(db, 'linkedin_articles', id));
//     toast('Article deleted');
//     fetchArticles();
//   };

//   const logout = async () => {
//     await auth.signOut();
//     navigate('/login');
//   };

//   useEffect(() => {
//     fetchArticles();
//   }, []);

//   return (
//     <div className={styles.dashboard}>
//       <header>
//         <h2>Admin Dashboard</h2>
//         <button onClick={logout}>Logout</button>
//       </header>

//       <ArticleForm refresh={fetchArticles} editingArticle={editingArticle} setEditingArticle={setEditingArticle} />

//       <div className={styles.list}>
//         {articles.map(article => (
//           <div className={styles.articleCard} key={article.id}>
//             <h3>{article.article_name}</h3>
//             <p>{article.article_brief}</p>
//             <div className={styles.actions}>
//               <button onClick={() => setEditingArticle(article)}>Edit</button>
//               <button onClick={() => handleDelete(article.id)}>Delete</button>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default AdminDashboard;
